var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "entry-carousel" }, [
    _c(
      "div",
      { staticClass: "swiper-container swiper-container--entry-carousel" },
      [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.cards, function(card, index) {
            return _c(
              "div",
              { key: index, staticClass: "w-1/3 swiper-slide card" },
              [
                _c("div", {
                  staticClass: "card__image object-fit",
                  domProps: { innerHTML: _vm._s(card.image) }
                }),
                _vm._v(" "),
                card.title
                  ? _c("h5", { staticClass: "card__title" }, [
                      _vm._v(_vm._s(card.title))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                card.text
                  ? _c("div", {
                      staticClass: "rte card__text",
                      domProps: { innerHTML: _vm._s(card.text) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                card.contentAvailable
                  ? _c(
                      "a",
                      {
                        staticClass: "card__read-more",
                        attrs: { href: card.url }
                      },
                      [_vm._v("Verder lezen")]
                    )
                  : _vm._e()
              ]
            )
          }),
          0
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "buttons" }, [
      _c(
        "svg",
        {
          staticClass: "buttons__prev-slide",
          attrs: { viewBox: "0 0 58 58", xmlns: "http://www.w3.org/2000/svg" }
        },
        [
          _c(
            "g",
            {
              attrs: {
                fill: "none",
                "fill-rule": "evenodd",
                transform: "matrix(-1 0 0 1 57 1)"
              }
            },
            [
              _c("circle", {
                attrs: { cx: "28", cy: "28", r: "28", stroke: "#1A3A1B" }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M44.5 27.41a4.91 4.91 0 01-4.904-4.679l-.005-.231H38.5a5.994 5.994 0 002.684 5.001L12.5 27.5v1h28.683a5.994 5.994 0 00-2.683 5h1.09l.006-.231A4.91 4.91 0 0144.5 28.59v-1.182z",
                  fill: "#0B1B0C",
                  "fill-rule": "nonzero"
                }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass: "buttons__next-slide",
          attrs: { viewBox: "0 0 58 58", xmlns: "http://www.w3.org/2000/svg" }
        },
        [
          _c(
            "g",
            {
              attrs: {
                fill: "none",
                "fill-rule": "evenodd",
                transform: "translate(1 1)"
              }
            },
            [
              _c("circle", {
                attrs: { cx: "28", cy: "28", r: "28", stroke: "#1A3A1B" }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M44.5 27.41a4.91 4.91 0 01-4.904-4.679l-.005-.231H38.5a5.994 5.994 0 002.684 5.001L12.5 27.5v1h28.683a5.994 5.994 0 00-2.683 5h1.09l.006-.231A4.91 4.91 0 0144.5 28.59v-1.182z",
                  fill: "#0B1B0C",
                  "fill-rule": "nonzero"
                }
              })
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }